const getters = {
  relation: state => state.app.relation
}

export default getters
